const o = "privacyPage", e = otto[o], { handleAppDseError: t, handleAppDseSuccess: c } = otto[o];
export {
  o as NEXUS_PRIVACY_PAGE_NAMESPACE,
  t as handleAppDseError,
  c as handleAppDseSuccess,
  e as privacyPage
};
